import React from 'react'
import AddTest from '../Components/AddTest/AddTest'

const AddTestView = () => {
  return (
    <div>
        <AddTest />
    </div>
  )
}

export default AddTestView